import React from "react";

import WarningTooltip from "../../../components/WarningTooltip";
import {BadgeForNew} from "../../../components/Badge";


export const DATA_INFO_TEXT =
  'Die Werte in diesen Feldern werden automatisch aktualisiert, ' +
  'sobald Daten geändert oder neu geladen werden. Auch manuell erfasste Werte können sich ändern, wenn sie in anderen ' +
  'Bereichen der Investmentsoftware bearbeitet werden.';

const InfoIcon = ({showNewBadge=false}) => (
  <><WarningTooltip title={DATA_INFO_TEXT} width={600} />{showNewBadge && <BadgeForNew />}</>
);

export default InfoIcon;